import type { Mapper } from '../../types/mappers/Mapper';
import type { TransportMode } from '../../types/models/TransportMode';
import type { MuiTransportModeOption } from '../../types/forms/MuiTransportModeOption';

export class MuiTransportModeMapper implements Mapper<TransportMode, MuiTransportModeOption> {
    mapToView(transportModeList: Array<TransportMode> | TransportMode): Array<MuiTransportModeOption> | MuiTransportModeOption {
        if (Array.isArray(transportModeList)) {
            return transportModeList.map((transportMode) => {
                return {
                    id: transportMode.transportModeId,
                    code: transportMode.code,
                    labelFR: transportMode.nameFR,
                    labelEN: transportMode.nameEN,
                    descriptionEN: transportMode.descriptionEN,
                    descriptionFR: transportMode.descriptionFR,
                    value: transportMode.code,
                };
            });
        }

        return {
            id: transportModeList.transportModeId,
            value: transportModeList.code,
            labelFR: transportModeList.nameFR,
            labelEN: transportModeList.nameEN,
            descriptionEN: transportModeList.descriptionEN,
            descriptionFR: transportModeList.descriptionFR,
        };
    }

    mapToModel(data: MuiTransportModeOption | MuiTransportModeOption[]): Array<TransportMode> | TransportMode {
        throw new Error('Exception: not implemented');
    }
}
